/*!
 * JM Product Fields v1.1 — personalisation fields for Jewelled Me product pages
 * (replaces King Product Options on photo / fingerprint / engraving products).
 * Config: product metafield custom.product_fields (json), e.g.
 *  { "fields": [
 *      { "type": "guide", "label": "Fingerprint guide", "image": "https://…", "text": "…" },
 *      { "type": "guide", "label": "How to take a fingerprint", "video": "<YouTube ID>" },
 *      { "type": "file",  "label": "Custom Fingerprint", "required": true, "hint": "…",
 *        "when": { "option": "Number of Pendants", "min": 2 } },
 *      { "type": "text",  "label": "Custom Text (back)", "placeholder": "Name (e.g. Asta)", "max": 11 },
 *      { "type": "choice","label": "Birthstone Bezel Colour", "options": ["Gold","Silver"], "hint": "…" }
 *  ], "hideApp": true }
 * "when": show the field only for matching variants — { "option": "<name contains>", "match": "<text>" }
 *          or { "option": "<name contains>", "min": 2 } for a count option (One/Two/Three or 1/2/3).
 * Each field is saved on the order as a line-item property named after its label
 * (files arrive as links to the uploaded image).
 */
(function () {
  'use strict';
  var cfgEl = document.querySelector('script[data-jmpf-config]');
  if (!cfgEl || window.__jmpf) return;
  window.__jmpf = true;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var fields = (cfg.fields && (cfg.fields.fields || cfg.fields)) || [];
  var opts = cfg.fields && cfg.fields.fields ? cfg.fields : {};
  if (!fields.length) return;

  var css = [
    '.jmpf{display:grid;gap:1em;margin:0 0 1.25em}',
    '.jmpf__f{display:grid;gap:.4em}',
    '.jmpf__f[hidden]{display:none}',
    '.jmpf__l{font-size:.75em;letter-spacing:.12em;text-transform:uppercase;opacity:.75;margin:0}',
    '.jmpf__req{color:#c0392b;margin-left:.15em}',
    '.jmpf__h{font-size:.8em;opacity:.65;margin:0}',
    '.jmpf__in{height:46px;padding:0 1em;font:inherit;border:1px solid rgba(0,0,0,.2);border-radius:10px;background:#fff;width:100%;box-sizing:border-box}',
    '.jmpf__in:focus{outline:2px solid #1a1a1a;outline-offset:1px}',
    '.jmpf__in.invalid,.jmpf__up.invalid{border-color:#c0392b;box-shadow:0 0 0 3px rgba(192,57,43,.15)}',
    '.jmpf__count{font-size:.72em;opacity:.55;text-align:right;margin:-.2em 0 0}',
    '.jmpf__up{display:flex;align-items:center;gap:.75em;padding:.55em .6em;border:1px dashed rgba(0,0,0,.28);border-radius:10px;background:#fff}',
    '.jmpf__btn{flex:none;height:40px;padding:0 1.1em;border:1px solid #1a1a1a;border-radius:999px;background:#1a1a1a;color:#fff;font:inherit;font-size:.9em;cursor:pointer}',
    '.jmpf__thumb{flex:none;width:40px;height:40px;border-radius:6px;object-fit:cover;background:#f2f2f2}',
    '.jmpf__thumb[hidden]{display:none}',
    '.jmpf__name{flex:1;min-width:0;font-size:.85em;opacity:.75;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.jmpf__rm{flex:none;border:0;background:none;font:inherit;font-size:.8em;text-decoration:underline;cursor:pointer;opacity:.7;padding:0}',
    '.jmpf__rm[hidden]{display:none}',
    '.jmpf__file{position:absolute!important;width:1px;height:1px;opacity:0;pointer-events:none}',
    '.jmpf__pills{display:flex;flex-wrap:wrap;gap:.5em}',
    '.jmpf__pill{position:relative}',
    '.jmpf__pill input{position:absolute;opacity:0;inset:0}',
    '.jmpf__pill span{display:inline-block;padding:.55em 1.1em;border:1px solid rgba(0,0,0,.2);border-radius:999px;background:#fff;font-size:.9em;cursor:pointer}',
    '.jmpf__pill input:checked+span{background:#1a1a1a;border-color:#1a1a1a;color:#fff}',
    '.jmpf__pill input:focus-visible+span{outline:2px solid #1a1a1a;outline-offset:2px}',
    '.jmpf__guide{justify-self:start;border:0;background:none;padding:0;font:inherit;font-size:.9em;text-decoration:underline;cursor:pointer}',
    '.jmpf__dlg{max-width:min(700px,92vw);border:0;border-radius:14px;padding:1.25em}',
    '.jmpf__dlg::backdrop{background:rgba(0,0,0,.45)}',
    '.jmpf__dlg img{display:block;max-width:100%;height:auto;border-radius:8px}',
    '.jmpf__vid{position:relative;width:min(640px,84vw);aspect-ratio:16/9;background:#000;border-radius:8px;overflow:hidden}',
    '.jmpf__vid iframe{position:absolute;inset:0;width:100%;height:100%;border:0}',
    '.jmpf__dlg h3{margin:.1em 2em .6em 0}',
    '.jmpf__x{float:right;border:0;background:none;font-size:1.5em;line-height:1;cursor:pointer}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  // main add-to-cart form (not the Shop Pay instalments form, not the sticky bar)
  var forms = Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
    if (/installment/i.test(f.className) || f.closest('shopify-payment-terms')) return false;
    var id = f.querySelector('[name="id"]');
    return id && (cfg.variants || []).some(function (v) { return String(v.id) === String(id.value); });
  });
  forms.sort(function (a, b) {
    var sa = /sticky/i.test((a.parentElement && a.parentElement.className) || '') ? 1 : 0;
    var sb = /sticky/i.test((b.parentElement && b.parentElement.className) || '') ? 1 : 0;
    return sa - sb;
  });
  var form = forms[0];
  if (!form) return;
  if (!form.id) form.id = 'jmpf-form';

  var box = el('div', 'jmpf', { 'data-jmpf': '' });
  var anchor = form.querySelector('.product-form__buttons') || form.querySelector('[type="submit"]');
  if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
  else form.insertBefore(box, form.firstChild);

  var rows = [];
  fields.forEach(function (f, i) {
    var id = 'jmpf-' + i + '-' + slug(f.label);
    var row = el('div', 'jmpf__f');
    var name = 'properties[' + (f.property || f.label) + ']';
    var label = function (forId) {
      var l = el(forId ? 'label' : 'p', 'jmpf__l', forId ? { for: forId } : null);
      l.textContent = f.label;
      if (f.required) { var r = el('span', 'jmpf__req', { 'aria-hidden': 'true' }); r.textContent = '*'; l.appendChild(r); }
      return l;
    };
    var hint = function () { if (!f.hint) return; var h = el('p', 'jmpf__h'); h.textContent = f.hint; row.appendChild(h); };
    var input = null;

    if (f.type === 'guide') {
      var b = el('button', 'jmpf__guide', { type: 'button' });
      b.textContent = f.label || 'Guide';
      var dlg = el('dialog', 'jmpf__dlg');
      var x = el('button', 'jmpf__x', { type: 'button', 'aria-label': 'Close' }); x.innerHTML = '&times;';
      x.addEventListener('click', function () { dlg.close(); });
      dlg.appendChild(x);
      var t = el('h3'); t.textContent = f.title || f.label; dlg.appendChild(t);
      if (f.text) { var p = el('p'); p.textContent = f.text; dlg.appendChild(p); }
      (f.images || (f.image ? [f.image] : [])).forEach(function (src) {
        var im = el('img', '', { src: src, alt: f.label || '', loading: 'lazy' }); dlg.appendChild(im);
      });
      var vid = null;
      if (f.video) {
        vid = el('div', 'jmpf__vid'); dlg.appendChild(vid);
        // video loads only when opened, and is removed on close so it stops playing
        dlg.addEventListener('close', function () { vid.innerHTML = ''; });
      }
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      b.addEventListener('click', function () {
        if (vid && !vid.firstChild) {
          var vidId = String(f.video).replace(/^.*(?:v=|youtu\.be\/|embed\/)/, '').replace(/[^\w-].*$/, '');
          vid.appendChild(el('iframe', '', {
            src: 'https://www.youtube-nocookie.com/embed/' + vidId + '?autoplay=1&rel=0&playsinline=1&modestbranding=1',
            title: f.title || f.label || 'Video', allow: 'autoplay; encrypted-media; picture-in-picture; fullscreen', allowfullscreen: ''
          }));
        }
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      });
      row.appendChild(b); document.body.appendChild(dlg);
    } else if (f.type === 'file') {
      row.appendChild(label(id));
      var up = el('div', 'jmpf__up');
      input = el('input', 'jmpf__file', { type: 'file', id: id, name: name, accept: f.accept || 'image/*' });
      var btn = el('button', 'jmpf__btn', { type: 'button' }); btn.textContent = f.button || 'Upload';
      var th = el('img', 'jmpf__thumb', { alt: '' }); th.hidden = true;
      var nm = el('span', 'jmpf__name'); nm.textContent = f.empty || 'No file chosen';
      var rm = el('button', 'jmpf__rm', { type: 'button' }); rm.textContent = 'Remove'; rm.hidden = true;
      btn.addEventListener('click', function () { input.click(); });
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        up.classList.remove('invalid');
        if (th.src) { try { URL.revokeObjectURL(th.src); } catch (e) {} }
        if (file) {
          nm.textContent = file.name; rm.hidden = false;
          if (/^image\//.test(file.type)) { th.src = URL.createObjectURL(file); th.hidden = false; } else th.hidden = true;
        } else { nm.textContent = f.empty || 'No file chosen'; rm.hidden = true; th.hidden = true; }
      });
      rm.addEventListener('click', function () { input.value = ''; input.dispatchEvent(new Event('change')); });
      up.appendChild(btn); up.appendChild(th); up.appendChild(nm); up.appendChild(rm); up.appendChild(input);
      row.appendChild(up); hint();
      row._mark = up;
    } else if (f.type === 'choice') {
      row.appendChild(label(null));
      var pills = el('div', 'jmpf__pills', { role: 'radiogroup', 'aria-label': f.label });
      (f.options || []).forEach(function (o, k) {
        var lab = el('label', 'jmpf__pill');
        var r = el('input', '', { type: 'radio', name: name, value: o, id: id + '-' + k });
        if (f.required && k === 0) r.setAttribute('data-jmpf-first', '');
        var s = el('span'); s.textContent = o;
        lab.appendChild(r); lab.appendChild(s); pills.appendChild(lab);
      });
      row.appendChild(pills); hint();
      input = pills;
    } else { // text
      row.appendChild(label(id));
      input = el('input', 'jmpf__in', { type: 'text', id: id, name: name, autocomplete: 'off' });
      if (f.placeholder) input.placeholder = f.placeholder;
      if (f.max) input.maxLength = f.max;
      row.appendChild(input);
      if (f.max) {
        var c = el('p', 'jmpf__count'); c.textContent = '0/' + f.max;
        input.addEventListener('input', function () { c.textContent = input.value.length + '/' + f.max; input.classList.remove('invalid'); });
        row.appendChild(c);
      }
      hint();
    }
    box.appendChild(row);
    rows.push({ f: f, row: row, input: input });
  });

  /* ----- show / hide by variant ----- */
  function variant() {
    var idIn = form.querySelector('[name="id"]');
    var id = idIn && idIn.value;
    return (cfg.variants || []).filter(function (v) { return String(v.id) === String(id); })[0] || null;
  }
  function optIndex(part) {
    var o = cfg.options || [];
    for (var i = 0; i < o.length; i++) if (String(o[i]).toLowerCase().indexOf(String(part).toLowerCase()) >= 0) return i;
    return -1;
  }
  var words = { one: 1, single: 1, two: 2, double: 2, dual: 2, three: 3, triple: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8 };
  function countOf(val) {
    var m = String(val).match(/\d+/); if (m) return parseInt(m[0], 10);
    var w = String(val).toLowerCase().match(/[a-z]+/g) || [];
    for (var i = 0; i < w.length; i++) if (words[w[i]]) return words[w[i]];
    return 1;
  }
  function visible(f, v) {
    var w = f.when; if (!w || !v) return true;
    var i = optIndex(w.option); if (i < 0) return true;
    var val = v.options[i] || '';
    if (w.match != null && String(val).toLowerCase().indexOf(String(w.match).toLowerCase()) < 0) return false;
    if (w.min != null && countOf(val) < w.min) return false;
    return true;
  }
  function setEnabled(r, on) {
    r.row.hidden = !on;
    var ins = r.input ? (r.input.tagName === 'INPUT' ? [r.input] : Array.prototype.slice.call(r.input.querySelectorAll('input'))) : [];
    ins.forEach(function (n) {
      n.disabled = !on;
      if (r.f.required && (n.type !== 'radio' || n.hasAttribute('data-jmpf-first'))) {
        if (on) n.setAttribute('required', ''); else n.removeAttribute('required');
      }
    });
  }
  var lastV = null;
  function sync() {
    var v = variant(), key = v ? v.id : 'none';
    if (key === lastV) return;
    lastV = key;
    rows.forEach(function (r) { setEnabled(r, visible(r.f, v)); });
  }
  sync();
  document.addEventListener('change', function () { setTimeout(sync, 60); });
  setInterval(sync, 500);

  /* ----- checks before add to cart (the theme also checks [required] fields) ----- */
  form.addEventListener('submit', function (e) {
    var bad = null;
    rows.forEach(function (r) {
      if (bad || r.row.hidden || !r.f.required || !r.input) return;
      var ok = r.f.type === 'choice' ? !!r.input.querySelector('input:checked')
        : r.f.type === 'file' ? !!(r.input.files && r.input.files.length)
        : !!r.input.value.trim();
      if (!ok) bad = r;
    });
    if (bad) {
      e.preventDefault(); e.stopImmediatePropagation();
      (bad.row._mark || bad.input).classList.add('invalid');
      bad.row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // leave empty optional fields out of the order (re-enabled straight after the theme reads the form)
    var off = [];
    Array.prototype.forEach.call(box.querySelectorAll('input'), function (n) {
      if (n.disabled) return;
      var empty = n.type === 'file' ? !(n.files && n.files.length) : n.type === 'radio' ? false : !n.value.trim();
      if (empty) { n.disabled = true; off.push(n); }
    });
    setTimeout(function () { off.forEach(function (n) { n.disabled = false; }); }, 0);
  }, true);

  // sticky add-to-cart bar: send it through the main form so the fields come along
  forms.slice(1).forEach(function (f2) {
    f2.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.click(); else form.requestSubmit ? form.requestSubmit() : form.submit();
    }, true);
  });

  /* ----- hide the old app fields (King Product Options) while both are installed ----- */
  if (opts.hideApp !== false) {
    var hideApp = function () {
      var ours = {};
      fields.forEach(function (f) { if (f.label) ours['ymq[' + f.label.toLowerCase() + ']'] = 1; });
      Array.prototype.forEach.call(document.querySelectorAll('[name^="ymq["]'), function (inp) {
        // only the app's copies of our own fields (never its variant pickers)
        if (!ours[String(inp.getAttribute('name')).toLowerCase()]) return;
        var n = inp.closest('[class*="ymq"]');
        if (!n) return;
        while (n.parentElement && /ymq/.test(n.parentElement.className || '') &&
               n.parentElement.querySelectorAll('input, select, textarea').length === n.querySelectorAll('input, select, textarea').length) n = n.parentElement;
        n.style.display = 'none';
      });
    };
    hideApp(); setTimeout(hideApp, 1200); setTimeout(hideApp, 3500);
  }
})();
